import { CONTACT_TYPES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(CONTACT_TYPES_ENDPOINT);
export default instance;
